import React from "react";
import {
    Heading,
    ListItem,
    List,
    Text
} from "spectacle";
import Button from '../components/Button';

const OurSolutionMain = () =>
    <div>
        <Heading size={6} textColor="secondary" caps bold>
            OUR SOLUTION
        </Heading>
        <Text textSize={30} textColor="primary">
            AI POWERED SLIDES
        </Text>
    </div>

export default OurSolutionMain;


// WEBPACK FOOTER //
// ./src/slides/OurSolutionMain.js